import values from 'lodash/values';
import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import createModelApi from "~/backend/modelApi";
import {getItemAction, getItemId, getModelName} from "~/stateGetter";
import {modify} from "mythil/object";
import invalidateLoadedModels from "~/reducers/helpers/invalidateLoadedModels";
import {openActionResult} from "~/actions/navigation_actions";
import identify from "~/identify";
import authenticatedRequest from "~/backend/authenticatedRequest";
import {getSaveValues} from "~/statePresenter";
import { getItemCustomActionResult } from '../../stateGetter';

const itemCustomAction = createSuccessPromiseThunk({
    func: async ({modelId, actionName, data, getState, gridName, dispatch, getConfig, customParams}) => {
        let state = getState(),
            itemId = getItemId(state, modelId),
            modelApi = createModelApi(
                getConfig().baseUrl,
                getModelName(state, modelId),
                (foo) => authenticatedRequest(foo, dispatch)
            ),
            saveValues = getSaveValues(state, modelId, gridName);

        let actionResult = await modelApi.performCustomItemAction(itemId, actionName, { ...saveValues, ...data }, customParams.tags);

        if(!actionResult.success) { return actionResult; }

        dispatch(openActionResult(actionResult));

        return actionResult;
    },
    name: 'customItemAction',
});

let execute = itemCustomAction.execute;
itemCustomAction.execute = (modelId, actionName, data, gridName, tags, ) => execute({modelId, actionName, data, gridName}, {modelId, actionName, tags});

let reduce = itemCustomAction.reduce;
itemCustomAction.reduce = (model, action) => {
    model = modify(model, 'itemCustomActionResult', (state) => {
        switch(action.type) {
            case itemCustomAction.types.SUCCESS:
                state = {
                    ...state,
                    status: identify.STATUS_SUCCESS,
                    finished_at: Date.now(),
                    value: {
                        messages: action.value.messages
                    }
                };
                break;
            default:
                state = reduce(state, action);
                break;
        }

        if(values(itemCustomAction.types).indexOf(action.type) > -1) {
            state = { ...state, actionName: action.actionName };
        }

        return state;
    });


    return model;
};


itemCustomAction.reduceState = (state, action) => {
    switch(action.type) {
        case itemCustomAction.types.SUCCESS:
            let itemAction = getItemAction(state, action.modelId, action.actionName);
            if(!itemAction.noReload) {
                return invalidateLoadedModels(state);
            }
        default:
            return state;
    }
};

const reduceCustomItemAction = itemCustomAction.reduce,
    CUSTOM_ITEM_ACTION_TYPES = itemCustomAction.types,
    performCustomItemAction = itemCustomAction.execute,
    reduceItemCustomActionState = itemCustomAction.reduceState,
    performCustomItemScanQrAction = (...args) => {
        return async (dispatch, getState) => {
            await dispatch(itemCustomAction.execute(...args));

            const {status} = getItemCustomActionResult(getState(), args[0]);
            return status === identify.STATUS_SUCCESS;
        }
    };

export {
    reduceCustomItemAction,
    CUSTOM_ITEM_ACTION_TYPES,
    performCustomItemAction,
    reduceItemCustomActionState,
    performCustomItemScanQrAction
}